import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class FinalidadesService {

  myAppUrl: string = "";

  constructor(private http: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.myAppUrl = baseUrl;
  }

  getFinalidades() {
    return this.http.get(this.myAppUrl + 'api/finalidad');
  }

  getFianlidadById(id: number) {
    return this.http.get(this.myAppUrl + 'api/finalidad/' + id);
  }

  createFinalidad(finalidad: any) {
    return this.http.post(this.myAppUrl + 'api/finalidad/', finalidad);
  }

  updateFinalidad(id: number, finalidad:any) {
    return this.http.put(this.myAppUrl + 'api/finalidad/' + id, finalidad);
  }
}
